import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// JS Files

// Others File
import callIcon from "../../imgs/footer-call.svg";
import LocationIcon from "../../imgs/footer-location.svg";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="footer flex  p-6 md:p-12 mt-10 md:mt-20 md:px-32">
        <div className="md:basis-2/5"></div>
        <div className="md:basis-3/5">
          <div className="grid md:grid-cols-4 gap-x-2">
            <div className="">
              <div className="border-r-4 border-white">
                <span className="text-white font-bold mr-2">پیوندها</span>
              </div>
              <ul className="list-none mt-4">
                <li className="mt-4">
                  <a href="https://iranianpooshesh.com/" target="_blank">
                    <span className="text-white text-sm cursor-pointer">
                      ایرانیان پوشش
                    </span>
                  </a>
                </li>
                <li className="mt-4">
                  <a href="https://medu.ir/" target="_blank">
                    <span className="text-white text-sm cursor-pointer">
                      آموزش و پرورش
                    </span>
                  </a>
                </li>
                <li className="mt-4">
                  <a href="https://www.dana-insurance.com/" target="_blank">
                    <span className="text-white text-sm cursor-pointer">
                      بیمه دانا
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="">
              <div className="border-r-4 border-white">
                <span className="text-white font-bold mr-2">دسترسی سریع</span>
              </div>
              <ul className="list-none mt-4">
                <li className="mt-4">
                  <span
                    onClick={() => navigate("/aboutus")}
                    className="text-white text-sm cursor-pointer"
                  >
                    درباره ما
                  </span>
                </li>
                <li className="mt-4">
                  <span
                    onClick={() => navigate("/contactus")}
                    className="text-white text-sm cursor-pointer"
                  >
                    تماس با ما
                  </span>
                </li>
                <li className="mt-4">
                  <a href="https://medu.ir/#news" target="_blank">
                    <span className="text-white text-sm cursor-pointer">
                      اخبار
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="mt-8 md:mt-0 col-span-2">
              <div className="border-r-4 border-white">
                <span className="text-white font-bold mr-2">راهای ارتباطی</span>
              </div>
              <ul className="list-none mt-4">
                <li className="mt-4 flex">
                  <img src={LocationIcon} className="self-start" />
                  <span className="text-white text-sm cursor-pointer mr-2">
                    تهران، ولی عصر ، ابتدای یوسف آباد ، خیابان سید جمال الدین
                    اسد آبادی ، خیابان هفتم ، پلاک ۱۴ ، ساختمان ایرانیان پوشش
                  </span>
                </li>
                <li className="mt-4 flex">
                  <a href="tel:1401">
                    <div className="flex items-center">
                      <img src={callIcon} className="self-start" />
                      <span className="text-white text-sm cursor-pointer mr-2">
                        تلفن مشاوره خسارت: ۱۴۰۱ بدون کد
                      </span>
                    </div>
                  </a>
                </li>
                {/* <li className="mt-4 flex">
                  <a href="tel:09120914895">
                    <div className="flex items-center">
                      <img src={callIcon} className="self-start" />
                      <span className="text-white text-sm cursor-pointer mr-2">
                        تلفن همراه واحد پشتیانی: ۷ الی ۰۹۱۲۰۹۱۴۸۹۵
                      </span>
                    </div>
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;
